import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Box,
    Typography,
} from '@mui/material';
import {getCondoId} from "../../../services/Main/AuthStorage";

export default function TemplateModalForm({ isOpen, onClose, onSubmit }) {
    const [modelName, setModelName] = useState('');
    const [file, setFile] = useState(null);

    const handleSubmit = () => {
        const formData = new FormData();

        formData.append('condo', getCondoId());
        formData.append('name', modelName);
        formData.append('file', file);
        onSubmit(formData);
        onClose();
        setModelName('');
        setFile(null);
    };

    return (
        <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Adicionar Modelo</DialogTitle>
            <DialogContent>
                <Box mt={1} display="flex" flexDirection="column" gap={2}>
                    <TextField
                        label="Nome do modelo"
                        value={modelName}
                        size={'small'}
                        onChange={(e) => setModelName(e.target.value)}
                        fullWidth
                    />

                    <Button variant="outlined" component="label">
                        {file ? file.name : 'Selecionar arquivo DOCX'}
                        <input
                            type="file"
                            accept=".doc,.docx,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                            hidden
                            onChange={(e) => setFile(e.target.files[0])}
                        />
                    </Button>
                    {file && (
                        <Typography variant="caption" color="text.secondary">
                            {file.name}
                        </Typography>
                    )}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="inherit">
                    Cancelar
                </Button>
                <Button
                    onClick={handleSubmit}
                    variant="contained"
                    disabled={!modelName || !file}
                >
                    Salvar
                </Button>
            </DialogActions>
        </Dialog>
    );
}
